import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

// Detecta cuando hay un despliegue nuevo comparando el hash del bundle de index.html
// (no-store) con el que está cargado, y ofrece actualizar sin perder nada.
const bundleHash = () => {
  const s = document.querySelector('script[src*="/static/js/main."]');
  const m = s && s.src.match(/main\.([a-z0-9]+)\.js/);
  return m ? m[1] : null;
};

export default function UpdateNotifier() {
  const [nueva, setNueva] = useState(false);

  useEffect(() => {
    const actual = bundleHash();
    if (!actual) return undefined;
    const check = async () => {
      try {
        const r = await fetch(`/index.html?ts=${Date.now()}`, { cache: "no-store" });
        const html = await r.text();
        const m = html.match(/main\.([a-z0-9]+)\.js/);
        if (m && m[1] !== actual) setNueva(true);
      } catch { /* sin conexión: se reintenta en el próximo ciclo */ }
    };
    const t = setInterval(check, 120000);
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(t);
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  if (!nueva) return null;
  return (
    <div
      data-testid="banner-nueva-version"
      className="fixed bottom-4 left-1/2 z-[70] flex -translate-x-1/2 items-center gap-3 rounded-xl border border-vino-200 bg-white px-4 py-3 shadow-lg"
    >
      <p className="text-sm text-slate-700">Hay una <strong>nueva versión</strong> de Roge disponible.</p>
      <button
        onClick={() => window.location.reload()}
        data-testid="btn-actualizar-version"
        className="flex items-center gap-2 rounded-lg bg-vino-700 px-3.5 py-1.5 text-xs font-semibold text-white hover:bg-vino-800"
      >
        <RefreshCw className="h-3.5 w-3.5" /> Actualizar ahora
      </button>
    </div>
  );
}
